import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { CancelWorkflowButton } from '../actions/CancelWorkflowButton';
import { CreateWorkflowButton } from '../actions/CreateWorkflowButton';

interface WorkflowCreateHeaderProps {
  onSubmit: () => void;
  onCancel?: () => void;
}

export const WorkflowCreateHeader: React.FC<WorkflowCreateHeaderProps> = ({ onSubmit, onCancel }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5 }}>
          Create New Workflow
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          Define a new automated workflow for ticket processing
        </Typography>
      </Box>
      <Stack direction="row" spacing={1}>
        <CancelWorkflowButton onCancel={onCancel} />
        <CreateWorkflowButton onSubmit={onSubmit} />
      </Stack>
    </Box>
  );
};

export default WorkflowCreateHeader;
